import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiBaseUrl } from '../../util/api';

const dynamicBaseQuery = async (args, api, extraOptions) => {
  const base = `${apiBaseUrl()}/api/transaction/`;
  const rawBaseQuery = fetchBaseQuery({ baseUrl: base, credentials: 'include' });
  return rawBaseQuery(args, api, extraOptions);
};

export const TransactionApi = createApi({
  reducerPath: 'TransactionApi',
  tagTypes: ['Transaction'],
  baseQuery: dynamicBaseQuery,
  endpoints: builder => ({
    sendMessageAndAttachFiles: builder.mutation({
      query: ({ transactionId, body }) => ({
        url: `${transactionId}/send-message-and-attach-files`,
        method: 'POST',
        body,
      }),
    }),
    deleteAttachedFile: builder.mutation({
      query: ({ transactionId, body }) => ({
        url: `${transactionId}/delete-attached-file`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useSendMessageAndAttachFilesMutation,
  useDeleteAttachedFileMutation,
} = TransactionApi;
